// Skip Link Injection
  document.addEventListener("DOMContentLoaded", function() {

  /**
   * ==========================================
   * HELPER: Inject Accessible Skip Link
   * ==========================================
   * Creates a "Skip to Content" link and injects it as the first child of a parent container.
   * This is critical for keyboard users to bypass repetitive navigation or annoying widgets.
   *
   * @param {string} targetSelector   - The CSS selector for the element you want to jump TO (e.g., 'main', '#results').
   * @param {string} parentSelector   - The CSS selector for the container the link should sit INSIDE (e.g., 'header', '.sidebar').
   * @param {string} linkText         - The visible text for the link (e.g., "Skip to content").
   * @param {string} [targetCustomId] - (Optional) If the target has no ID, assign this ID to it so the link works.
   * @param {string} [skipLinkId]     - (Optional) A specific ID for the link itself (e.g., 'skip-link-filter') for CSS styling.
   *
   * @example
   * // Basic global skip link
   * injectSkipLink('main', 'header', 'Skip to content');
   * * // Specific link with custom IDs
   * injectSkipLink('.search-results', '.sidebar', 'Skip filters', 'results-container', 'skip-link-filter');
   */
  function injectSkipLink(targetSelector, parentSelector, linkText, targetCustomId, skipLinkId) {
    const targetElement = document.querySelector(targetSelector);
    const parentElement = document.querySelector(parentSelector);

    // Only proceed if both elements exist on the current page
    if (targetElement && parentElement) {
      
      // 1. Ensure the target has an ID (required for href anchor)
      if (!targetElement.id) {
        targetElement.id = targetCustomId || 'content';
      }

      // 2. Create the link element
      const skipLink = document.createElement('a');
      skipLink.href = '#' + targetElement.id;
      skipLink.className = 'skip-to-content-link'; 
      
      // 3. Assign a specific ID to the link itself (if provided) 
      // This allows us to use ID selectors in CSS (#skip-link-filter) rather than !important
      if (skipLinkId) {
        skipLink.id = skipLinkId;
      }
      
      skipLink.textContent = linkText;

      // 4. Inject as the FIRST child of the parent
      // This ensures it is the first tab stop when entering the section
      parentElement.insertBefore(skipLink, parentElement.firstChild);
    }
  }

  // ==========================================
  // EXECUTION
  // ==========================================

  // 1. Global Site Skip (Header -> Main)
  // ------------------------------------
  // Injects into the main header. Points to the main content area.
  // CSS Selector: #skip-link-global
  injectSkipLink('main', 'header', 'Skip to main content', 'content', 'skip-link-global');


  // 2. Search & Collection Page Skip (Sidebar -> Results)
  // -----------------------------------------------------
  // Bypasses the lengthy filter sidebar on collection/search pages.
  // CSS Selector: #skip-link-filter
  injectSkipLink(
    '.collection-content',           // Target: The product grid wrapper
    '.collection-sidebar-container', // Parent: The sidebar wrapper
    'Skip filters and view results', // Text
    'collection-results-target',     // ID assigned to Target (if missing)
    'skip-link-filter'               // ID assigned to this specific Link
  );

});